import React from "react";
import { styled } from "styled-components";
import rem from "../../utils/rem";
const StyledTransparentButton = styled.button `
  border: 0;
  background: transparent;
  appearance: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: inline-flex;
  /* accessibility */
  min-width: ${rem(36)};
  min-height: ${rem(36)};
  justify-content: center;
  align-items: center;

  &:hover {
    /* todo add some generic hover shadow to the icon with filter here.*/
    /*
    svg {
      filter: drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.7));
    }
     */
  }
`;
export const TransparentIconButton = ({ icon, iconColor, size = 30, children, ...props }) => {
    const Icon = icon;
    return (React.createElement(StyledTransparentButton, { ...props },
        React.createElement(Icon, { width: size, height: size, color: iconColor }),
        children));
};
export default TransparentIconButton;
//# sourceMappingURL=TransparentIconButton.js.map